import axios from 'axios';
import { CNode_url, NODE_URL, PerformanceURL,encryptStorage } from '../constant';
// import { encode, decode } from 'base-64';
import { composeApi } from './api';

const decodeJwtToken = (token) => {
    try {
        // Split the token into its three parts: header, payload, and signature
        const [headerEncoded, payloadEncoded] = token.split('.');

        // Decode the base64-encoded payload
        const payload = JSON.parse(atob(payloadEncoded));
        return payload;
    } catch (error) {
        console.error('Error decoding JWT token:', error.message);
        return null;
    }
};

export function getSessionToken() {
    try {
        let token = encryptStorage.getItem('jwtToken');

        if (token == undefined) {
            window.location.href = '/';
        } else {
            // Replace with your actual JWT token
            let value = decodeJwtToken(token);
            if (encryptStorage.getItem('employeeId') == value?.empId) {
                return token;
            } else {
                window.location.href = '/';
            }
        }
    } catch (error) {
        throw error;
    }
}
//PC_BI_05 & PC_BI_18 & PC_EM_07 & PC_FB_21 -> client() function is defined
export async function client(body) {
    //function client triggers PC_RC_25 PC_PA_12 PC_HC_18 PC_HC_45 PC_HC_57
    try {
        let bodyData = body;

        bodyData['jwt'] = encryptStorage.getItem('jwtToken');
        bodyData['emp_id'] = encryptStorage.getItem('employeeId');
        bodyData['groupId'] = encryptStorage.getItem('groupid');

        // bodyData['groupId'] = encryptStorage.getItem('groupid');
        const dat = await composeApi(JSON.stringify(body));

        //create a variable config and store the method, url, data PC_RC_26 //PC_PA_13 PC_HC_19 PC_HC_46 PC_HC_58
        var config = {
            method: 'post',
            url: NODE_URL,
            headers: {
                'Content-Type': 'application/json',
            },
            data: dat,
        };

        let token = getSessionToken();
        let groupId = encryptStorage.getItem('groupid');
        let panelMember = encryptStorage.getItem('recruitRole');
        if (token !== undefined && (groupId == 1 || panelMember == 'Panel Member' || (body.modulename == 12 && body.methodname == 2))) {
            //PC_RC_27 axios call
            let response = await axios(config);
            // response.data = response?.data; //PC_RC_28

            return response; //PC_RC_29 //PC_PA_16 return the response received
        }
    } catch (e) {
        throw e;
    }
}

export async function candidateclient(body) {
    body['jwt'] = encryptStorage.getItem('jwtToken');
    body['emp_id'] = encryptStorage.getItem('employeeId');
    const dat = await composeApi(JSON.stringify(body));

    var config = {
        method: 'post',
        url: CNode_url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: dat,
        // encode(random(2) + (encode(JSON.stringify({ ...body, authorization: `Bearer ` })) + random(2))),
    };
    let token = getSessionToken();
    if (token !== undefined) {
        let response = await axios(config);
        let data;
        if (response.data == null) {
            data = response.data;
            return data;
        } else {
            data = response.data;
            return data;
        }
    }
}
export async function performanceClient(body) {
    // //debugger
    body['jwt'] = encryptStorage.getItem('jwtToken');
    body['emp_id'] = encryptStorage.getItem('employeeId');
    body['groupId'] = encryptStorage.getItem('groupid');
    const dat = await composeApi(JSON.stringify(body));

    var config = {
        method: 'post',
        url: PerformanceURL,
        headers: {
            'Content-Type': 'application/json',
        },
        data: dat,
    };

    let token = getSessionToken();
    if (token !== undefined) {
        let response = await axios(config);
        // response.data = response.data;
        return response;
    }
}
